var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode2Black24Dp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "qr_code_2_black_24dp_svg__qr_code_2_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    viewBox: "2 2 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qr_code_2_black_24dp_svg__Group_868",
    "data-name": "Group 868"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "qr_code_2_black_24dp_svg__Rectangle_382",
    "data-name": "Rectangle 382"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "qr_code_2_black_24dp_svg__Path_876",
    "data-name": "Path 876",
    d: "M19,27H16.333V24.333H19Zm-2.667-9.333H13.667v6.667h2.667ZM27,15H24.333v5.333H27Zm-2.667-2.667H21.667V15h2.667ZM8.333,15H5.667v2.667H8.333ZM5.667,12.333H3V15H5.667ZM15,5.667h2.667V3H15ZM5,5V9H9V5Zm6,6H3V3h8ZM5,21v4H9V21Zm6,6H3V19h8ZM21,5V9h4V5Zm6,6H19V3h8ZM24.333,24.333v-4H19V23h2.667v4H27V24.333ZM21.667,15H16.333v2.667h5.333Zm-5.333-2.667h-8V15H11v2.667h2.667V15h2.667ZM17.667,11V8.333H15V5.667H12.333V11ZM8,6H6V8H8ZM8,22H6v2H8ZM24,6H22V8h2Z",
    transform: "translate(1 1)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode2Black24Dp);
export default __webpack_public_path__ + "static/media/qr_code_2_black_24dp.c63f1916181880fe2fdf5094cc28dba8.svg";
export { ForwardRef as ReactComponent };